import React from "react";
import { useIntl } from "react-intl";
import ChartTooltip from "../ChartTooltip";
import "./ResizeHandle.sass";

/**
 * Pill under the time axis, like moon.com: dragging it up or down changes the
 * chart height, a double click resets it (useChartHeightFactor).
 *
 * @param {object} props
 * @param {boolean} props.isDragging - keeps the hover look while dragging
 * @param {object} props.handleProps - pointer handlers from useChartHeightFactor
 */
const ResizeHandle = ({ isDragging, handleProps }) => {
  const intl = useIntl();
  const label = intl.formatMessage({ id: "futures.chart.resize" });

  return (
    <div className="resize-handle">
      <ChartTooltip label={label} placement="top" size="large">
        <button
          type="button"
          className={`resize-handle__btn${isDragging ? " resize-handle__btn--dragging" : ""}`}
          aria-label={label}
          {...handleProps}
        />
      </ChartTooltip>
    </div>
  );
};

export default ResizeHandle;
